// extracted by mini-css-extract-plugin
module.exports = {"content":"TimeoutItem_content__P7mSl"};